import icon from './linkedin.svg';

import type { Provider } from '../providers'

export default {
    key: 'linkedin',
    name: 'LinkedIn',
    color: '#0077b5',
    icon
} satisfies Provider;
